import { render, staticRenderFns } from "./GalleriesForm.vue?vue&type=template&id=de93cbae&scoped=true"
import script from "./GalleriesForm.vue?vue&type=script&lang=js"
export * from "./GalleriesForm.vue?vue&type=script&lang=js"
import style0 from "./GalleriesForm.vue?vue&type=style&index=0&id=de93cbae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de93cbae",
  null
  
)

export default component.exports